import { AutogenLayoutInvoiceProcessingCreditRebillErrorSlideout } from "./autogen/AutogenLayoutInvoiceProcessingCreditRebillErrorSlideout";

export class InvoiceProcessingCreditRebillErrorSlideout extends AutogenLayoutInvoiceProcessingCreditRebillErrorSlideout {
    
}
    